import { Transition } from '@headlessui/react';
import cn from '../../app/utils/cn';
import BrandLockup from './BrandLockup';
import Loader from './Loader';

interface ISplashScreenProps {
  isLoading: boolean;
}
export default function SplashScreen({ isLoading }: ISplashScreenProps) {
  return (
    <Transition show={isLoading}>
      <div
        className={cn(
          'bg-surface-page flex h-full !w-full flex-col items-center justify-center gap-6',
          'absolute transition ease-in-out',
          'data-[closed]:opacity-0',
          'data-[enter]:duration-100 data-[enter]:data-[closed]:-translate-x-full',
          'data-[leave]:duration-200 data-[leave]:data-[closed]:translate-x-full',
        )}
      >
        <BrandLockup orientation="stacked" />

        <Loader />
      </div>
    </Transition>
  );
}
